export const blue = {
  400: "#009eff",
};

export const black = {
  100: "#f7f7f7",
  200: "#98a0a6",
  300: "#E0E0E0",
  400: "#161616",
  500: "#363636",
  600: "#F4F4F4",
  700: "#B0B6BA",
};

export const red = {
  400: "#EA253D",
};

export const white = {
  400: "#fff",
};
